export enum UiActionTypes {
  GET_DARK_MODE_OR_DEFAULT = 'GET_DARK_MODE_OR_DEFAULT',
}

export enum UiMutationTypes {
  SET_FORCE_DARK_MODE = 'SET_FORCE_DARK_MODE',
  UPDATE_WINDOW_SIZE = 'UPDATE_WINDOW_SIZE'
}